import { Player } from "@lottiefiles/react-lottie-player"
import CTABtn from "components/CTABtn"
import { Column } from "components/Layout"
import utils from "modules/utils"
import { useEffect } from "react"
import Modal from "react-modal"
import { useLocalStorage } from "react-use"
import colors from "styles/colors"


const PlayFTUE = ({ scrollContainerRef, onCompleted }) => {
  // const [modalIsOpen, setModalIsOpen] = useState(true)
  // const [scrollAnimationPlayed, setScrollAnimationPlayed] = useState(false)

  const [FTUEModalCompleted, setFTUEModalCompleted] = useLocalStorage(
    "playablesFTUEModalCompleted",
    false
  )
  const [FTUEScrollCompleted, setFTUEScrollCompleted] = useLocalStorage(
    "playablesFTUEScrollCompleted",
    false
  )

  useEffect(() => {
    const scrollContainerEl = scrollContainerRef?.current
    if (!scrollContainerEl) return


    function handleFTUECompleted() {
      scrollContainerEl.style.scrollSnapType = "y mandatory"
      setFTUEScrollCompleted(true)
    }

    scrollContainerEl.addEventListener("scroll", handleFTUECompleted)

    return () => {
      scrollContainerEl.removeEventListener("scroll", handleFTUECompleted)
    }
  }, [scrollContainerRef, onCompleted])

  function closeFTUEModal() {
    // setScrollAnimationPlayed(false)
    setFTUEModalCompleted(true)
  }

  if (FTUEModalCompleted && FTUEScrollCompleted) return null

  return <>
    <Modal isOpen={!FTUEModalCompleted} shouldCloseOnOverlayClick={false}>
      <Column align="mc" gap="xl">
        {/* For some reason this lottie will crash the app, tali is making a new one, the image is a temporary solution */}
        <img src="/img/play_ftue.png" alt="" width={220} height={180} />
        {/* <Player
          autoplay
          loop
          src={utils.fetchLottie("/lottie/play_ftue_modal.json")}
          style={{ height: 200, width: "100%" }}
        /> */}

        <Column align="mc" gap="sm" style={{ textAlign: "center" }}>
          <h3>Play without installing</h3>
          <h4 style={{ color: colors.textLight }}>Swipe up to discover new games and tap to play them instantly!</h4>
        </Column>

        <CTABtn wide type="large" onClick={closeFTUEModal}>
          Let the Games Begin!
        </CTABtn>
      </Column>
    </Modal>

    <Player
      autoplay
      loop
      src={utils.fetchLottie("/lottie/play_ftue_scroll_hint.json")}
      style={{
        opacity: FTUEModalCompleted ? 1 : 0,
        transition: "opacity 1s",
        pointerEvents: "none",
        width: 80,
        position: "fixed",
        left: "calc(50% - 40px)",
        bottom: "6rem",
      }}
    />
  </>
}

export default PlayFTUE
